
import React from "react";
import Header from "./Header";
import Footer from "./Footer";

function FreeQuote() {
  return (
    <div>
      <Header />
      <div className="container-fluid bg-primary py-5 bg-header" style={{marginBottom: "90px"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Free Quote</h1>
                    <a href="/" className="h5 text-white">Home</a>
                    <i className="far fa-circle text-white px-2"></i>
                    <a href="/free-quote" className="h5 text-white">Free Quote</a>
                </div>
            </div>
      </div>
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-12">
              <div className="section-title position-relative pb-3 mb-5">
                <h5 className="fw-bold text-primary text-uppercase">Request A Quote</h5>
                <h1 className="mb-0">Need A Free Quote? Please Feel Free to Connect!</h1>
              </div>
              <div className="row g-5">
                <div className="col-lg-7">
                  <div className="row gx-3">
                    <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                      <h5 className="mb-4">
                        <i className="fa fa-reply text-primary me-3"></i>Reply within 24
                        hours
                      </h5>
                    </div>
                    <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                      <h5 className="mb-4">
                        <i className="fa fa-phone-alt text-primary me-3"></i>24 hrs
                        telephone support
                      </h5>
                    </div>
                  </div>
                  <p className="mb-4 fs-5">
                    Have questions, inquiries, or simply want to discuss how our
                    digital marketing strategies can elevate your brand? </p>
                    <p className="mb-4 fs-5">We'd love to hear from you! Our team of experienced professionals is here to
                    provide personalized solutions tailored to your unique business
                    needs.</p>
                    <p className="mb-4 fs-5">Your success story may start with a simple message – reach
                    out now!</p>
                  <div
                    className="d-flex align-items-center mt-2 wow zoomIn"
                    data-wow-delay="0.6s"
                  >
                    <div
                      className="bg-primary d-flex align-items-center justify-content-center rounded"
                      style={{width: "60px", height: "60px"}}>
                      <i className="fa fa-phone-alt text-white fs-2"></i>
                    </div>
                    <div className="ps-4">
                      <h5 className="mb-2">Call to ask any question</h5>
                      <h4 className="text-primary mb-0">+971 55 730 6504</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div
                    className="bg-primary rounded h-100 d-flex align-items-center p-5 wow zoomIn"
                    data-wow-delay="0.9s"
                  >
                    <form>
                      <div className="row g-3">
                        <div className="col-xl-12">
                          <input
                            type="text"
                            className="form-control bg-light border-0"
                            placeholder="Your Name"
                            style={{height: "55px"}}/>
                        </div>
                        <div className="col-12">
                          <input
                            type="email"
                            className="form-control bg-light border-0"
                            placeholder="Your Email"
                            style={{height: "55px"}}/>
                        </div>
                        <div className="col-12">
                          <select
                            className="form-select bg-light border-0"
                            style={{height: "55px"}}
                            defaultValue="">
                            <option value="">Select A Service</option>
                            <option value="1">SEO Services</option>
                            <option value="2">SEM Services</option>
                            <option value="3">Social Media Marketing</option>
                            <option value="4">Web Development</option>
                            <option value="5">Content Writing</option>
                          </select>
                        </div>
                        <div className="col-12">
                          <textarea
                            className="form-control bg-light border-0"
                            rows="3"
                            placeholder="Message"
                          ></textarea>
                        </div>
                        <div className="col-12">
                          <button className="btn btn-dark w-100 py-3" type="submit">
                            Request A Quote
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FreeQuote;